module.exports = __webpack_public_path__ + "img/boca.84607d51.png";